import { useAppSelector } from '@common/hooks/store';
import { userLoggedIn } from '@features/auth/slice/authSlice';
import React, { createContext, PropsWithChildren, useCallback, useContext, useState } from 'react';
import RecommendedExpressSheet from './RecommendedExpressSheet';

const RecommendedExpressContext = createContext<() => void>(() => undefined);

export const useOpenRecommendedExpress = () => useContext(RecommendedExpressContext);

export default function RecommendedExpressProvider({ children }: PropsWithChildren) {
  const loggedIn = useAppSelector(userLoggedIn);
  const [ open, setOpen ] = useState(false);
  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  return (
    <RecommendedExpressContext.Provider value={handleOpen}>
      {children}
      {loggedIn && <RecommendedExpressSheet open={open} onClose={handleClose}/>}
    </RecommendedExpressContext.Provider>
  );
}
